import React, { Component } from 'react';

import {observer} from 'mobx-react'

import styles from './style.sass';

export default observer(({intersection, organizations}) =>
    <ul className={styles.root}>
        {organizations.map((organization, i) =>
            <li key={organization.slug}>
                <a href={organization.homepage}>
                    <Image src={organization.logo.normal} intersection={intersection} />
                </a>
            </li>
        )}
    </ul>
);

class Image extends Component {

    constructor(props, context) {
        super(props, context);

        this.setRef = this.setRef.bind(this);
    }

    setRef(element) {
        if (this.props.intersection !== undefined) {
            if (element) {
                this.$el = element;
                this.props.intersection.observe(element)
            } else {
                this.props.intersection.unobserve(this.$el);
            }
        }
    }

    render() {
        return this.props.intersection
            ? <img data-src={this.props.src} ref={this.setRef} />
            : <img src={this.props.src} />
    }
}


// WEBPACK FOOTER //
// ./src/modules/Partners/elements/OrganizationsLogoList/index.js